import { apiGet, apiPost, apiPut, apiDelete } from '../services/api';

export interface Country {
  id: number;
  name: string;
}

export interface GetManyCountriesParams {
  q?: string;
  sort_by?: string;
  sort_order?: string;
  per_page?: number;
}

export interface GetManyCountriesResult {
  data: Country[];
  total?: number;
}

export async function getMany(
  params: GetManyCountriesParams = {},
): Promise<GetManyCountriesResult> {
  const queryParams = new URLSearchParams();

  if (params.q !== undefined) queryParams.append('q', params.q);
  if (params.sort_by) queryParams.append('sort_by', params.sort_by);
  if (params.sort_order) queryParams.append('sort_order', params.sort_order);
  if (params.per_page) queryParams.append('per_page', params.per_page.toString());

  const response = await apiGet<GetManyCountriesResult>(
    `/api/countries?${queryParams.toString()}`,
  );

  return response;
}

export async function getAllCountries(): Promise<Country[]> {
  const response = await getMany({
    q: '',
    sort_by: 'name',
    sort_order: 'asc',
    per_page: 100,
  });

  return response.data || [];
}

export async function getOne(id: number): Promise<Country> {
  const response = await apiGet<Country>(`/api/countries/${id}`);
  return response;
}

export async function createOne(data: Partial<Omit<Country, 'id'>>): Promise<Country> {
  const response = await apiPost<Country>('/api/countries', data);
  return response;
}

export async function updateOne(
  id: number,
  data: Partial<Omit<Country, 'id'>>,
): Promise<Country> {
  const response = await apiPut<Country>(`/api/countries/${id}`, data);
  return response;
}

export async function deleteOne(id: number): Promise<void> {
  await apiDelete(`/api/countries/${id}`);
}

